import React, { useState, useEffect, useContext } from 'react';
import { Comment, Typography } from 'antd';
// import CommentEditor from "./CommentEditor";
import CommentHeader from './comment-header';
import { CaretDownOutlined, CaretRightOutlined } from '@ant-design/icons';
// Hooks
import { useInView } from 'react-intersection-observer';
import CommentForm from './comment-form.js';
// Style
import './comments_.less';
import AvatarGroup from '../../avatar/AvatarGroup';
import TextEditorReadOnly from '../../text/TextEditorReadOnly';
import { appContext } from '../../../AppContext';

export default function SingleComment({ comment: propsComment, actions: propsActions, isChild: propsIsChild }) {
    const [appState] = useContext(appContext);

  const [editMode, setEditMode] = useState(false);
  const [editValue, setEditValue] = useState(propsComment.content);
  const [showReplies, setShowReplies] = useState(true);
  const [content, setContent] = useState();

  const userId = appState.user.id;

  useEffect(
    () => {
      if (
        userId === propsComment.larperId ||
        propsComment.personsWatched.filter((r) => r.larperId === userId).length > 0
      ) {
        return;
      }
      propsActions.addUnreadComment(propsComment.id);
    }, // eslint-disable-next-line
    []
  );

  function AddReplyComment(parentId, content, onlySl) {
    propsActions.addComment(propsComment.id, content, onlySl);
    return true;
  }

  // edit mode
  function handleEditClick() {
    setEditValue(propsComment.content);
    setEditMode(true);
  }
  function handleSaveClick(id, value) {
    propsActions.saveComment(propsComment.id, value);
    setEditMode(false);
    return true;
  }

  function handleCancelEditor() {
    setEditMode(false);
  }

  function handleDeleteClick() {
    propsActions.deleteComment(propsComment.id);
  }

  function handleOnClickHide() {
    propsActions.hideComment(propsComment.id);
  }

  // Recognize if new comment has been read by user
  const { ref, inView } = useInView({
    threshold: 0.3,
    triggerOnce: true,
  });


  function getContent(content) {
    if (propsComment.deleted === true) {
      return (
        <>
          <Typography.Text className="comment deleted-text">
            {`${propsComment.larperName} has deleted this comment`}
          </Typography.Text>
        </>
      );
    }
    return <TextEditorReadOnly content={propsComment.content} />;
  }

  const stylingReply = propsComment.parentId === null ? 'comment' : 'comment comment-reply';

  const commentContent = () => {
    return (
      <>
        <CommentHeader
          onClickEdit={handleEditClick}
          onClickDelete={handleDeleteClick}
          onClickHide={handleOnClickHide}
          showReplies={showReplies}
          toggleReplies={handleToggleReplies}
          comment={propsComment}
          userPermission={userId === propsComment.larperId}
          editMode={editMode}
          unread={propsComment.isRead}
          isChild={propsIsChild}
          currentUserId={userId}
          commentRead={propsActions.commentRead}
        />

        <div>
          {editMode ? (
            <CommentForm
              className="comment-reply-form"
              onSubmit={handleSaveClick}
              content={editValue}
              setContent={setContent}
              isActive
              cancel={handleCancelEditor}
              editMode={editMode}
            />
          ) : (
            getContent(propsComment.content)
          )}
        </div>
      </>
    );
  };

  function handleToggleReplies() {
    setShowReplies(!showReplies);
  }

  function getCommenters(arr) {
    const me = userId;

    let commenters = arr.reduce((acc, item) => {
      const personId = item.larperId;
      const personName = item.larperName;

      if (!acc.includes(personId)) {
        if (personId === me) {
          acc = ['You', ...acc];
        } else {
          acc.push(personName);
        }
      }
      return acc;
    }, []);

    // Remove duplicates
    let filteredCommenters = commenters.reduce((unique, item) => {
      return unique.includes(item) ? unique : [...unique, item];
    }, []);

    return filteredCommenters;
  }

  return (
    <section
      className={`comment comment-card ant-card ant-card-bordered ${
        !propsComment.isRead && 'unread'
      }`}
    >
      <Comment
        className={stylingReply}
        key={propsComment.id}
        content={<div ref={ref}>{commentContent(propsComment)}</div>}
      >
        {propsComment.parentId === null && propsComment.children.length !== 0 && showReplies && (
          <div className="comment-reply-hidden" onClick={() => handleToggleReplies(false)}>
            <CaretDownOutlined style={{ marginRight: 8 }} />
            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
              Hide replies
            </Typography.Text>
          </div>
        )}
        {showReplies &&
          propsComment.children &&
          propsComment.children.map((childComment) => (
            <SingleComment
              className="comments-reply"
              key={childComment.id}
              comment={childComment}
              actions={propsActions}
              isChild={true}
            />
          ))}
        {!showReplies && (
          <div className="comment-reply-hidden" onClick={() => handleToggleReplies(true)}>
            <CaretRightOutlined style={{ marginRight: 8 }} />
            <Typography.Text type="secondary" style={{ fontSize: 12, marginRight: 8 }}>
              show {propsComment.children.length} replies from
            </Typography.Text>
            <AvatarGroup children={getCommenters(propsComment.children)} size="small" />
          </div>
        )}
        {propsComment.parentId === null && showReplies && (
          <CommentForm
            className="comment-reply-form"
            onSubmit={AddReplyComment}
            content={content}
            setContent={setContent}
            placeholder={"Write a reply"}
            commentBoxMode
          />
        )}
      </Comment>
    </section>
  );
}
